import { capitalizeFirstLetter } from "./utility";


export const PAYMENT_MODE_LABELS = {
  cash: "Cash",
  card: "Card",
  upi: "UPI",
  cheque: "Cheque",
  imps: "IMPS",
  rtgs: "RTGS",
  neft: "NEFT",
  others: "Others",
};

export const SELECTABLE_PAYMENT_MODES = [
  "cash",
  "upi",
  "card",
  "cheque",
  "imps",
  "rtgs",
  "neft",
];


export const getPaymentModeLabel = (mode, otherMode) => {
  if (mode === "others") return otherMode || PAYMENT_MODE_LABELS.others;
  if (!mode) return "";
  return PAYMENT_MODE_LABELS[mode] || capitalizeFirstLetter(mode);
};
